import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from "moment";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { LosService } from "src/app/_LOS/services/los.service";
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { constantUrl } from "src/app/Shared/constantUrl";
import { DialogService } from "src/app/Shared/dialog.service";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
declare var $;

@Component({
  selector: "app-receipt-authentication",
  templateUrl: "./receipt-authentication.component.html",
  styleUrls: ["./receipt-authentication.component.scss"],
})
export class ReceiptAuthenticationComponent implements OnInit {
  ToDate: any = new Date();
  FromDate: any = new Date();
  AccountTag: any = "";
  Dramt = 0;
  Cramt = 0;
  currentUser: any;
  DrData: any;
  Status = "Pending";
  VID: any;
  Reason: any;
  JsonData: any[] = [];
  showSpinner: boolean = false;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  AccountDocUrl: any = constantUrl.AccountDocUrl;
  // Voucher Model Variables
  dataSourceModel: MatTableDataSource<any> = new MatTableDataSource([]);
  displayedColumnsModel: any = [];
  loanSummary: any;
  Tenure_Name: any;
  //Customer data
  dataSourceCustomer: MatTableDataSource<any> = new MatTableDataSource([]);
  displayedCustomerColumns: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  attachedFile: any;
  accountTagDropdown: any[];
  @ViewChild(MatPaginator, { read: MatPaginator }) set matPaginator(
    paginator: MatPaginator
  ) {
    if (paginator != undefined) {
      this.dataSourceCustomer.paginator = paginator;
    }
  }
  constructor(
    private _losService: LosService,
    private lmsService: LmsService,
    private snackBar: MatSnackBar,
    private dialog: DialogService,
    private quickLoanService: QuickLoanService,
    private dataSharingService: DataSharingService
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Bank Receipt Authorization");
    this.Get_Acc_Accounts_By_Tag();
  }

  OnCloseVoucherModel() {
    $("#VoucherModel").modal("hide");
  }

  showVoucherModel() {
    $("#VoucherModel").modal("show");
  }

  OnShowVoucherModel(LoanId, VId, Status) {
    this.Get_Voucher_Data(LoanId, VId, Status);
    this.showVoucherModel();
  }
  Get_Acc_Accounts_By_Tag() {
    this.lmsService
      .Get_Acc_Accounts_By_Tag({
        LoginUserId: this.currentUser.userId,
        Account_Tag: "Bank",
        Voucher_Date: new Date(),
      })
      .subscribe((res: any) => {
        this.accountTagDropdown = res;
      });
  }

  Get_Receipt_Data_From_Date() {
    this.dataSourceCustomer = new MatTableDataSource([]);
    this.showSpinner = true;
    let requestData = {
      FromDate: moment(this.FromDate).format("YYYY-MM-DD").toString(),
      ToDate: moment(this.ToDate).format("YYYY-MM-DD").toString(),
      Status: this.Status,
      AccountId: Number(this.AccountTag),
      LoginUserId: this.currentUser.userId,
    };
    // console.log("Request", requestData)
    this._losService
      .QuickLoan_Get_Fees_Web(requestData)
      .subscribe((res: any[]) => {
        console.log("Response", res);
        const filteredData = res.filter((x) => x.Voucher_Tag == "Bank");
        if (filteredData.length == 0) {
          this.snackBar
            .openFromComponent(SnackbarComponent, {
              data: "No Data Found",
              ...this.configSuccess,
            })
            ._dismissAfter(500);
        }
        this.JsonData = JSON.parse(JSON.stringify(filteredData));
        this.dataSourceCustomer = new MatTableDataSource(filteredData);
        this.paginator = this.dataSourceCustomer.paginator;
        if (this.Status == "Rejected") {
          this.displayedCustomerColumns = [
            "Id",
            "ApplicationNo",
            "LoanAcNo",
            "Voucher_Type",
            "Voucher_Sub_Type",
            "Voucher_Tag",
            "Voucher_Date",
            "CreatedBy",
            "CreatedOn",
            "Account_Name",
            "Amount",
            "Origin",
            "Reason",
            "EditAction",
          ];
        } else
          this.displayedCustomerColumns = [
            "Id",
            "ApplicationNo",
            "LoanAcNo",
            "Voucher_Type",
            "Voucher_Sub_Type",
            "Voucher_Tag",
            "Voucher_Date",
            "CreatedBy",
            "CreatedOn",
            "Account_Name",
            "Amount",
            "Origin",
            "EditAction",
          ];

        this.showSpinner = false;
      });

    //Send Request and Fetch Data
  }

  Get_Voucher_Data(LoanId: any, VId: any, Status: any) {
    const requestData = { LoanId, VId, Status };
    this.showSpinner = true;

    console.log("request", requestData);

    this._losService.QuickLoan_Get_Fees_Details(requestData).subscribe({
      next: (response: any) => {
        console.log("response", response);

        const items = response?.Item2 ?? [];

        // Loan summary
        this.loanSummary = response?.Item1?.[0] ?? null;

        // DR row
        this.DrData = items.find((x: any) => x?.TranType === "DR");

        // Attached file
        this.attachedFile = items?.[0]?.Voucher_Doc ?? null;
        console.log("attached File", this.attachedFile);

        // Table data
        this.dataSourceModel = new MatTableDataSource<any>(items);

        // Amount calculations (SAFE)
        this.Dramt = Number(this.DrData?.Amount ?? 0);

        const totalAmount = items.reduce(
          (sum: number, curr: any) => sum + Number(curr?.Amount ?? 0),
          0
        );

        this.Cramt = totalAmount - this.Dramt;

        // Table columns
        this.displayedColumnsModel = [
          "TranType",
          "Case_No",
          "Customer",
          "Branch",
          "Category",
          "Account_Name",
          "AmountDR",
          "AmountCR",
        ];

        this.showVoucherModel();
        this.showSpinner = false;
      },
      error: (err) => {
        console.error("API error", err);
        this.showSpinner = false;
      },
    });
  }

  onApproval(VID) {
    this.dialog
      .openConfirmDialog(`Are you sure you want to Approve?`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.quickLoanService
            .QuickLoan_Save_Fees_Detail({
              VID: VID,
              LoginUserId: this.currentUser.userId,
              Status: "Approved",
            })
            .subscribe((resp) => {
              // console.log("Confrmesponse Data",resp)
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: resp[0]["MSG"],
                ...this.configSuccess,
              });
              if (resp[0]["CODE"] === 0) {
                this.OnCloseVoucherModel();
                this.Get_Receipt_Data_From_Date();
              }
            });
        }
      });
  }
  onRejected() {
    this.dialog
      .openConfirmDialog(`Are you sure you want to Reject?`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.quickLoanService
            .QuickLoan_Save_Fees_Detail({
              VID: this.VID,
              LoginUserId: this.currentUser.userId,
              Status: "Rejected",
              Reason: this.Reason,
            })
            .subscribe((resp) => {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: resp[0].MSG,
                ...this.configSuccess,
              });
              if (resp[0].CODE === 0) {
                this.Reason = "";
                this.VID = null;
                this.OnCloseVoucherModel();
                this.OnCloseRejectModel();
                this.Get_Receipt_Data_From_Date();
              }
            });
        }
      });
  }
  onRejectedDone(VID) {
    this.VID = VID;
    $("#RejectModel").modal("show");
  }
  OnCloseRejectModel() {
    $("#RejectModel").modal("hide");
  }

  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById("imd_auth") as HTMLTableElement;
    const worksheetName = "IMD AUTHORIZATION"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  applyFilter(filterValue: string) {
    this.dataSourceCustomer.filter = filterValue.trim().toLowerCase();
  }
}
